<div class="container-fluid form-container  p-0 m-0 ">
  <div class="row h-100 g-0 min-vh-100">
    <div class="col-md-6  d-flex align-items-center justify-content-center  position-relative min-vh-100 left-hero">
      <img 
      ngSrc="/assets/images/trace-image.png" 
      width="700" 
      height="600"
      priority
      alt="hero image"
      class="hero-img"
    />
    </div>
    <div class="col-md-6 col-12 form-section d-flex align-items-center position-relative">
      <div class="w-100">
        <div class="form-box mx-auto">
          <div class="email-confirmation-message text-center mx-auto" *ngIf="!showToaster">
            <svg width="100" height="100" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="150" height="150" rx="40" fill="#4E3162" />
              <path
                d="M114.145 71.0732C114.145 78.9034 111.841 86.1962 107.874 92.3107L101.497 81.1528C98.0691 75.155 89.4217 75.155 85.9939 81.1528L70.68 107.951C70.3336 108.555 70.0686 109.175 69.8777 109.802C50.7543 107.261 36 90.8895 36 71.0732C36 49.4929 53.4947 32 75.0732 32C96.6516 32 114.145 49.4929 114.145 71.0732Z"
                stroke="white" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M75.0732 51.5391V71.0751L84.8413 80.8432M93.7456 93.4021V98.9838M109.059 121.311H78.4326C72.2737 121.311 68.1807 115.334 69.8779 109.805C70.0688 109.178 70.3338 108.558 70.6802 107.954L85.9941 81.1556C89.4219 75.1579 98.0693 75.1579 101.497 81.1556L107.875 92.3135L116.811 107.954C120.211 113.905 115.914 121.311 109.059 121.311Z"
                stroke="white" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M93.7455 112.926C95.1993 112.926 96.5921 111.647 96.5248 110.146C96.4574 108.641 95.3036 107.367 93.7455 107.367C92.2917 107.367 90.8989 108.645 90.9662 110.146C91.0337 111.652 92.1874 112.926 93.7455 112.926Z"
                fill="white" />
              <path
                d="M75.0732 32V37.5818M47.445 43.444L51.3918 47.3908M36.001 71.0723H41.5827M47.445 98.7005L51.3918 94.7537M114.145 71.0723H108.564M102.701 43.444L98.7545 47.3908"
                stroke="white" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <h1 class="text-brand-purple mt-2"> <b> Session Expired!</b></h1>
            <span class="verfication-message">This verification link is not valid anymore.</span>
            <button type="submit" class="btn bg-brand-purple text-white w-100 rounded-12 mt-3 mb-4"
              [disabled]="isResetBtnDisabled" (click)="resendEmail()">
              Resend Email
            </button>
            <span class="verfication-message" *ngIf="showTimer">Didn’t receive verification email? <span
                class="text-brand-purple"><b> {{buttonText}} </b></span> </span>
          </div>
          <div class="email-confirmation-message text-center" *ngIf="showToaster">
            <h3 class="text-brand-purple mt-2"> <b>{{message}}</b></h3>
            <!-- <span class="verfication-message"></span> -->
            <p class="mt-3">Please go to <a href="#" class="text-brand-purple" [routerLink]="['/login']">Login </a></p>
          </div>
        </div>

        <p class="text-center small footer-text position-absolute bottom-0 start-0 end-0 text-brand-dark-purple mb-2">
          2025 Trace.
          All rights reserved.</p>
      </div>
    </div>
  </div>
</div>